import { Component, inject } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BasePageComponent } from '../../../../_shared/components/page/base-page.component';
import { CommonModule, Location } from '@angular/common';
import { ProductsInstalledWidgetComponent } from '../widgets/products-installed/products-installed-widget.component';
import { FuelConsumptionWidgetComponent } from '../widgets/fuel-consumption/fuel-consumption-widget.component';
import { InspectionsAndComplianceWidgetComponent } from '../widgets/inspections-and-compliance/inspections-and-compliance-widget.component';
import { TotalDowntimeWidgetComponent } from '../widgets/total-downtime/total-downtime-widget.component';
import { AssetInformationComponent } from '../asset-information/asset-information.component';
import { MaintenanceComponent } from '../maintenance/maintenance.component';
import { ComplianceComponent } from '../compliance/compliance.component';
import { CreateMaintenanceModalComponent } from '../../../_shared/components/modals/create-maintenance-modal/create-maintenance-modal.component';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-asset-overview-details',
  standalone: true,
  imports: [
    CommonModule,
    ProductsInstalledWidgetComponent,
    FuelConsumptionWidgetComponent,
    InspectionsAndComplianceWidgetComponent,
    TotalDowntimeWidgetComponent,
    AssetInformationComponent,
    MaintenanceComponent,
    ComplianceComponent,
    TranslocoDirective
  ],
  templateUrl: './asset-overview-details.component.html',
  styleUrl: './asset-overview-details.component.scss'
})
export class AssetOverviewDetailsComponent extends BasePageComponent {
  private modalService = inject(NgbModal);
  private location = inject(Location);
  private readonly transloco: TranslocoService = inject(TranslocoService);

  assetId: number;
  assetName: string;
  activeTab: 'asset-information' | 'maintenance' | 'compliance' = 'asset-information';

  constructor() {
    super();
    this.assetId = Number.parseInt(this.route.snapshot.params['assetId']);
    this.assetName = this.route.snapshot.params['assetName'];

    if (!this.assetId || !this.assetName) this.router.navigate(['/asset-management/asset-overview']);
  }

  /**
   * The asset name is a route parameter, so a rename has to rewrite the URL as well as the
   * header - otherwise refreshing the page restores the old name from the route.
   */
  onAssetRenamed(assetName: string): void {
    this.assetName = assetName;
    this.location.replaceState(
      `/asset-management/asset-overview/asset-details/${this.assetId}/${encodeURIComponent(assetName)}`);
  }

  onBackButtonClick(): void {
    this.router.navigate(['/asset-management/asset-overview']);
  }

  onScheduleMaintenanceClick(): void {
    const modalRef = this.modalService.open(CreateMaintenanceModalComponent, {
      size: 'md',
      centered: true,
      backdrop: 'static',
      container: 'body'
    });

    modalRef.componentInstance.modalTitle = this.transloco.translate('assetOverview.details.scheduleMaintenance');
    modalRef.componentInstance.modalSubtitle = this.transloco.translate('assetOverview.details.scheduleMaintenanceSubtitle');
    modalRef.componentInstance.lockedAssetId = this.assetId;
    modalRef.componentInstance.lockedAssetName = this.assetName;
  }

  protected override onRefresh(): void { }
  protected override shouldRefresh(): boolean { return false; }
  protected override getFilters(): any { return {}; }
  protected override applyPageFilterState(pageFilter: any): void { }
}